import {
	BusinessController,
	SupportController,
} from '../../controllers';
import React, { useState } from 'react';
import { Settings } from '../../pages/Settings';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { useStores } from '../../stores';

const { faqCategories, contactDetails } = SupportController;

const SettingsContainer = () => {
	const [businessInfo, setBusinessInfo] = useState(false);
	const [securityModal, setSecurityModal] = useState(false);
	const [inviteFriendsModal, setInviteFriendsModal] = useState(false);
	const [supportModal, setSupportModal] = useState(false);
	const [faqModal, setFaqModal] = useState(false);
	const [logoutModal, setLogoutModal] = useState(false);
	const [withdrawalAccountModal, setWithdrawalAccountModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [kycModal, setKycModal] = useState(false);
	const [tier, setTier] = useState('Tier 0');

	const { userStore, businessStore } = useStores();
	const [generalSettingsModal, setGeneralSettingsModal] = useState(false);

	const navigate = useNavigate();


	const goToBusinessInfo = () => {
		setBusinessInfo(true);
	};

	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			BusinessController.businessDetails(),
		]);
		setLoading(false);
	};

	const goToSecurity = () => {
		setSecurityModal(true);
	};

	const goToWithdrawalAccount = () => {
		// isOnboardingDone();
		setWithdrawalAccountModal(true);
	};

	const goToInvite = () => {
		setInviteFriendsModal(true);
	};
	const goToSupport = () => {
		setSupportModal(true);
	};
	const goTologout = () => {
		setLogoutModal(true);
	};
	const goToFaq = () => {
		setFaqModal(true);
	};

	const goToGeneralSettings = () => {
		setGeneralSettingsModal(true);
	};

	const goToApiKeys = () => {
		navigate(constant.Routes.ApiKeys);
	};

	const isActivated = userStore?.isActivated;
	const hasPin = userStore?.user?.hasPin;
	const isOnboarded = userStore?.isOnBoardingDone !== 'false';
	const hasWithdrawal = businessStore?.business?.withdrawalBankAccount;
	const hasBizReg = false;

	let [a, b, c, d, e] = [0, 0, 0, 0, 0];

	isActivated ? (a = 25) : (a = 0);
	isOnboarded ? (b = 25) : (b = 0);
	hasPin ? (c = 25) : (c = 0);
	hasWithdrawal ? (d = 25) : (d = 0);
	hasBizReg ? (e = 25) : (e = 0);

	const goToKyc = () => {
		if (isActivated && isOnboarded && hasBizReg) {
			setTier('Tier 3');
		} else if (isActivated && isOnboarded) {
			setTier('Tier 2');
		} else if (isActivated) {
			setTier('Tier 1');
		}
		// setTier("Tier 1")
		setKycModal(true);
	};

	const closeModal = () => {
		// await BusinessController.businessDetails();
		setBusinessInfo(false);
		setSecurityModal(false);
		setInviteFriendsModal(false);
		setSupportModal(false);
		setLogoutModal(false);
		setWithdrawalAccountModal(false);
		setKycModal(false);
		setFaqModal(false);
		setGeneralSettingsModal(false);
	};

	return (
		<div>
			<Settings
				generalSettingsModal={generalSettingsModal}
				goToGeneralSettings={goToGeneralSettings}
				businessInfo={businessInfo}
				goToBusinessInfo={goToBusinessInfo}
				inviteFriendsModal={inviteFriendsModal}
				supportModal={supportModal}
				logoutModal={logoutModal}
				faqModal={faqModal}
				goToSecurity={goToSecurity}
				securityModal={securityModal}
				withdrawalAccountModal={withdrawalAccountModal}
				goToWithdrawalAccount={goToWithdrawalAccount}
				goToKyc={goToKyc}
				kycModal={kycModal}
				tier={tier}
				goToInvite={goToInvite}
				loading={loading}
				goToSupport={goToSupport}
				goTologout={goTologout}
				goToFaq={goToFaq}
				closeModal={closeModal}
				refresh={refresh}
				goToApiKeys={goToApiKeys}
			/>
		</div>
	);
};

export default SettingsContainer;
